export default __webpack_public_path__ + "static/media/image-grid.a8ce4f2b.jpg";